module.exports = __webpack_public_path__ + "assets/bubble-back-da196a4f7491cc012674ead46c78834a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/styles/assets/bubble-back.svg
// module id = 102
// module chunks = 0